exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".portfolio-page-container {\n  width: 100%;\n  min-height: 100%;\n  background-color: #ebebeb;\n  box-sizing: border-box;\n  padding-top: 100px; }\n\n.portfolio-element-container {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-pack: center;\n      justify-content: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/BenLeech/portfolio-website/portfolio-website/src/app/components/portfolio/portfolio.component.scss
// module id = ../../../../../src/app/components/portfolio/portfolio.component.scss
// module chunks = 1